module.exports = __webpack_public_path__ + "img/Search.a7e29030.svg";